import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = {
  class: "text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0",
  role: "row"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "fw-bold text-black" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "odd"
}
const _hoisted_8 = {
  colspan: "9",
  class: "dataTables_empty pt-10 pb-6 fs-3"
}
const _hoisted_9 = {
  key: 0,
  class: "overlay-layer card-rounded bg-dark bg-opacity-5"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-success",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_14 = {
  key: 0,
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "10" }, "10", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "25" }, "25", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "50" }, "50", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "100" }, "100", -1)
const _hoisted_19 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", {
        class: _normalizeClass([[_ctx.loadingRef && 'overlay overlay-block'], "table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer"]),
        id: "kt_customers_table",
        role: "grid"
      }, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, i) => {
              return (_openBlock(), _createElementBlock("th", {
                key: i,
                onClick: ($event: any) => (
                  _ctx.sort(
                    cell.sortingField ? cell.sortingField : cell.key,
                    cell.sortable
                  )
                ),
                class: _normalizeClass(["text-center", [
                  cell.sortable && 'table-header',
                  cell.sortable !== false && 'sorting',
                  _ctx.currentSort ===
                    `${cell.sortingField ? cell.sortingField : cell.key}desc` &&
                    'sorting_desc',
                  _ctx.currentSort ===
                    `${cell.sortingField ? cell.sortingField : cell.key}asc` &&
                    'sorting_asc',
                ]]),
                tabindex: "0",
                rowspan: "1",
                colspan: "1",
                style: _normalizeStyle(cell.sortable && 'cursor: pointer')
              }, _toDisplayString(cell.name), 15, _hoisted_4))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_5, [
          (_ctx.getItems.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getItems, (item, i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: i,
                  style: _normalizeStyle(_ctx.width < 567 && _ctx.url ? 'cursor: pointer' : ''),
                  onClick: ($event: any) => (
                  _ctx.width < 567 && _ctx.url ? _ctx.router.push(`${_ctx.url}/${item.id}`) : null
                ),
                  class: "odd"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (cell, j) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: j,
                      style: _normalizeStyle(
                      cell.key === 'image' &&
                      _ctx.tableHeader.length === 2 &&
                      'width: 33%'
                    ),
                      class: "text-center"
                    }, [
                      _renderSlot(_ctx.$slots, `cell-${cell.key}`, {
                        row: item,
                        index: i,
                        cell: j
                      }, () => [
                        _createTextVNode(_toDisplayString(item[_ctx.prop]), 1)
                      ])
                    ], 4))
                  }), 128))
                ], 12, _hoisted_6))
              }), 128))
            : _createCommentVNode("", true),
          (!_ctx.loadingRef && !_ctx.getItems.length)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.emptyTableText), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.loadingRef)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "summary")
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        (_ctx.enableItemsPerPageDropdown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setItemsPerPage && _ctx.setItemsPerPage(...args))),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pagination.rowsPerPage) = $event))
                }, _hoisted_19, 544), [
                  [_vModelSelect, _ctx.pagination.rowsPerPage]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_el_pagination, {
          "current-page": _ctx.pagination.page,
          "onUpdate:current-page": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination.page) = $event)),
          onCurrentChange: _ctx.currentPageChange,
          "page-size": _ctx.pagination.rowsPerPage,
          layout: "prev, pager, next",
          total: _ctx.pagination.total,
          "hide-on-single-page": true,
          background: ""
        }, null, 8, ["current-page", "onCurrentChange", "page-size", "total"])
      ])
    ])
  ]))
}